<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homet' }" replace>首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/Mistake' }" replace>错题批改</el-breadcrumb-item>
				<el-breadcrumb-item>{{ type == 0 ? '待批改' : '已完成' }}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="p_m_t_30 p_flex" :style="{ height: height + 'px' }">
			<div class="p_f_1 deatil_content overflow">
				<div class="list_box p_b_b">
					<div class="two-overflow type_size_22">
						我是题目内容内容内容内容内容内容内容内容内容内容内容内容内容内容我是题目内容内容内容内容内容内容内容内容内容内容内容内容内容内容...
					</div>
					<div class="p_flex p_f_a p_f_b p_m_t_20">
						<div class="p_flex p_f_1 one-overflow p_m_r_30">我是作业名称</div>
						<div class="p_flex type_size_16">
							<span class="subject_color">高一(2)</span>
							<el-divider direction="vertical"></el-divider>
							<span>张三</span>
						</div>
					</div>
				</div>
				<div class="suggest p_m_t_20" v-if="type == 1">
					<div class="suggest_box subject_yellow type_size_16">
						建议：内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
					</div>
				</div>
				<div class="p_m_l_60 p_m_r_60 subject_color correct"  v-if="type == 1">
					 <el-divider>回答正确</el-divider>
				</div>
				<div class="list_box type_size_18" >答:马克思两个最伟大的发现是唯物史观和剩余价值学说, 实现了人类思想史上的伟大革命, 而科学社会主义在唯物史观和剩</div>
				<div class="suggest" v-if="type == 0">
					<div class="suggest_box subject_yellow type_size_16">
						建议：内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
					</div>
				</div>
				
				<div class="content_list small_hand">
					<div class="content_box p_b_b p_b_l p_b_t " @click="goSuggest">
						<div class="p_flex p_f_c zi_ti subject_yellow">
							<span class="el-icon-message"></span>
						</div>
						<span>建议</span>
					</div>
					<div class="content_box p_b_l ">
						<div class="p_flex p_f_c zi_ti" style="color: #F1282E;">
							<span class="el-icon-circle-close"></span>
						</div>
						<span>打错</span>
					</div>
					<div class="content_box p_b_b p_b_l p_b_t ">
						<div class="p_flex p_f_c zi_ti subject_color">
							<span class="el-icon-circle-check"></span>
						</div>
						<span>答对</span>
					</div>
				</div>
			</div>
			<div class="deatil_list p_m_l_20 overflow" :style="{ height: height - 80 + 'px' }">
				<!-- <detail-list :type="type"></detail-list> -->
			</div>
		</div>
		<!-- <pop-up :show='show' @closes='closes' @goButton='goButton'></pop-up> -->
	</div>
</template>

<script>
// import DetailList from './commponents/detailList.vue';
// import PopUp from './commponents/popUp.vue'
export default {
	name: 'WrongDetails',
	components: {
		// DetailList,
		// PopUp
	},
	data() {
		return {
			type: '0',
			height: 0,
			show:false
		};
	},
	mounted() {
		this.type = this.$route.query.type;
		this.indexInfo();
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/WrongDetails') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},

	methods: {
		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var height = box - head - 30;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
		goSuggest(){
			this.show = true
		},
		// 关闭按钮
		closes(val){
			this.show = val
		},
		// 下发作业确认按钮
		goButton(val){
			this.show = val
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	}
};
</script>

<style lang="scss" scoped>
.deatil_list {
	width: 380px;
	background: #ffffff;
}
.deatil_content {
	position: relative;
	height: 100%;
	background: #ffffff;
}
.list_box {
	padding: 20px 0;

	margin: 0 60px;
}
.content_list{
	position: absolute;
	bottom: 100px;
	right: 0;
}
.content_box{
	padding: 16px;
	font-size: 12px;
}
.zi_ti{
	font-size: 18px;
	margin-bottom: 5px;
}
.suggest{
	padding: 20px ;
	margin: 0 60px 0;
	background: #FFFAF2;
	opacity: 1;
	border-radius: 20px;
}
.correct >>>.el-divider{
	background-color: #00AF63;
}
.correct >>>.el-divider__text{
	color: #00AF63;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/mistake/details.vue